import React from 'react';
import FiltersBar from '../../../../Table/FiltersBar';
import useOdataGet from '../../../../customHooks/useOdataGet';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import TextInput from '../../../../muiComponents/TextInput/TextInput';
import { useHotelsList } from '../../contexts/HotelsListContext';
import {
    doubleMD_ColumnGrid,
    gridSpacing10,
    gridSpacing15,
} from '../../../../utils/commonVariables/grid';
import useTranslate from '../../../../customHooks/useTranslate';
import LoadedOptionsTypeahead from '../../../../muiComponents/LoadedOptionsTypeahead';
import { readOnlyEntities } from '../../../../utils/commonVariables/entityKeys';
import { IFilterOptionState } from '../../../../types/lists/listTypes';

const HotelsFiltersBar = () => {
    const translate = useTranslate();
    const {
        handleFilterChange,
        filters,
        handleSearch,
        resetFilters,
        isLoading,
        currentResults,
        totalResults,
    } = useHotelsList();

    const bookingStatusEndpoint = {
        entity: readOnlyEntities.ZitoneoPublishStatusType,
        select: 'Id,LocalizedCaption,Caption,Name,Color,Key',
        filter: 'Enabled',
    };
    const statusRequest = useOdataGet(bookingStatusEndpoint);
    return (
        <FiltersBar
            title={translate('properties')}
            currentResults={currentResults}
            totalResults={totalResults}
            isLoading={isLoading}
            clearFilters={resetFilters}
            search={handleSearch}
        >
            <Grid columnSpacing={gridSpacing15} rowSpacing={gridSpacing10}>
                <GridChild gridProps={doubleMD_ColumnGrid}>
                    <TextInput
                        id='hotelName'
                        labelText='hotel_name'
                        value={filters.name.value}
                        handleChange={(
                            _e: React.ChangeEvent<HTMLInputElement>,
                            newValue: string
                        ) => {
                            handleFilterChange('name', newValue);
                        }}
                        onKeyDown={(
                            e: React.KeyboardEvent<HTMLInputElement>
                        ) => {
                            if (e.key === 'Enter') {
                                handleSearch(1);
                            }
                        }}
                    />
                </GridChild>
                <GridChild gridProps={doubleMD_ColumnGrid}>
                    <LoadedOptionsTypeahead
                        labelText={'status'}
                        options={statusRequest.options}
                        id={'status'}
                        value={filters.status.value || null}
                        handleChange={(
                            _e: React.SyntheticEvent<Element, Event>,
                            newValue: IFilterOptionState | null
                        ) => handleFilterChange('status', newValue)}
                    />
                </GridChild>
            </Grid>
        </FiltersBar>
    );
};

export default HotelsFiltersBar;
